import type { CiteType } from './types';

export const CITE_TYPE_CONFIG: Record<CiteType, {
  /** Clé i18n du libellé — à passer à t() au rendu */
  labelKey: string;
  color: string;
  icon:  string;
  /** Clé i18n de la description — à passer à t() au rendu */
  descKey:  string;
}> = {
  meme_affaire: {
    labelKey: 'fiche.cite.meme_affaire.label',
    color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
    icon:  '🔄',
    descKey:  'fiche.cite.meme_affaire.desc',
  },
  reference_jurisprudentielle: {
    labelKey: 'fiche.cite.reference_jurisprudentielle.label',
    color: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
    icon:  '⭐',
    descKey:  'fiche.cite.reference_jurisprudentielle.desc',
  },
  application_principe: {
    labelKey: 'fiche.cite.application_principe.label',
    color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
    icon:  '✅',
    descKey:  'fiche.cite.application_principe.desc',
  },
  distinction: {
    labelKey: 'fiche.cite.distinction.label',
    color: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
    icon:  '↗️',
    descKey:  'fiche.cite.distinction.desc',
  },
  obiter_dictum: {
    labelKey: 'fiche.cite.obiter_dictum.label',
    color: 'bg-muted text-muted-foreground',
    icon:  '💬',
    descKey:  'fiche.cite.obiter_dictum.desc',
  },
  revirement: {
    labelKey: 'fiche.cite.revirement.label',
    color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
    icon:  '🔁',
    descKey:  'fiche.cite.revirement.desc',
  },
  confirmation: {
    labelKey: 'fiche.cite.confirmation.label',
    color: 'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400',
    icon:  '✓',
    descKey:  'fiche.cite.confirmation.desc',
  },
};

/** labelKey : clé i18n à passer à t() au rendu */
export const IMPACT_CONFIG: Record<string, { labelKey: string; color: string; icon: string }> = {
  revirement:             { labelKey: 'fiche.impact.revirement', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',             icon: '🔁' },
  restriction:            { labelKey: 'fiche.impact.restriction', color: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400', icon: '↘' },
  extension:              { labelKey: 'fiche.impact.extension', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',     icon: '↗' },
  confirmation_renforcee: { labelKey: 'fiche.impact.confirmation_renforcee', color: 'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400',         icon: '✓✓' },
};

/** labelKey : clé i18n à passer à t() au rendu */
export const PROC_LINK_CONFIG: Record<string, { labelKey: string; color: string; icon: string }> = {
  casse:                  { labelKey: 'fiche.proc_link.casse', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',             icon: '⚡' },
  cassation_sans_renvoi:  { labelKey: 'fiche.proc_link.cassation_sans_renvoi', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',             icon: '⚡' },
  cassation_partielle:    { labelKey: 'fiche.proc_link.cassation_partielle', color: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400', icon: '◑' },
  rejette:                { labelKey: 'fiche.proc_link.rejette', color: 'bg-muted text-muted-foreground',                                           icon: '✗' },
  rapprochement:          { labelKey: 'fiche.proc_link.rapprochement', color: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400', icon: '≈' },
  jonction:               { labelKey: 'fiche.proc_link.jonction', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',         icon: '⊕' },
  renvoi_apres_cassation: { labelKey: 'fiche.proc_link.renvoi_apres_cassation', color: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400', icon: '↩' },
  judilibre_contested:    { labelKey: 'fiche.proc_link.judilibre_contested', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',             icon: '⬆' },
  judilibre_timeline:     { labelKey: 'fiche.proc_link.judilibre_timeline', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',         icon: '→' },
  judilibre_forward:      { labelKey: 'fiche.proc_link.judilibre_forward', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',     icon: '⬇' },
  judilibre_rapprochement:{ labelKey: 'fiche.proc_link.judilibre_rapprochement', color: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400', icon: '≈' },
  judilibre_numbers:      { labelKey: 'fiche.proc_link.judilibre_numbers', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',         icon: '⊕' },
};